<template><div><h1>VUX V2.10.1 released</h1>
<h2><a href="/en/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[fix] fix word count bug #3784</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.10.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.10.1-88.vue?3c5e80be